"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoInsightClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class AutoInsightClient extends authenticated_client_1.AuthenticatedClient {
    getAutoInsightScoring(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = {
                mappingId: body.page,
                goalId: body.goal,
                startDate: body.from,
                endDate: body.to,
                deviceId: body.device,
                discardedInsights: body.discardedInsights,
                recordingOrigin: body.recordingOrigin,
                toCurrency: body.toCurrency,
                segment: body.segment,
            };
            const response = yield this.httpPost(`/v1/projects/${projectId}/auto-insight/scoring`, request);
            return response.payload;
        });
    }
    getAutoInsightScoringReplays(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = {
                aliasId: body.aliasId,
                startDate: body.from,
                endDate: body.to,
                deviceId: body.device,
                segment: body.segment,
                insight: body.insight,
            };
            const response = yield this.httpPost(`/v1/projects/${projectId}/auto-insight/scoring/replays`, request);
            return response.payload;
        });
    }
    getDiscardedInsights(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users/me/insights/discarded`);
            if (!response.payload) {
                return [];
            }
            return response.payload;
        });
    }
    updateDiscardedInsights(projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/users/me/insights/discarded`, payload);
            return response.payload;
        });
    }
    getAutoInsighScoringReplaysV2(projectId, { from, to, deviceId, firstResultRank, lastResultRank, achievedGoals, goal }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const path = `/v1/projects/${projectId}/auto-insight/session-replay/listPagesRecorded`;
            const request = {
                from,
                to,
                deviceId,
                firstResultRank,
                lastResultRank,
                achievedGoals,
                goal,
            };
            const response = yield this.httpPost(path, request);
            return response.payload;
        });
    }
}
exports.AutoInsightClient = AutoInsightClient;
//# sourceMappingURL=auto-insight.client.js.map